<template>
    <div class="individual">
        <div class="individual-box">
            <div class="individual-tit">
                <div class="individual-tit-left">
                    <span class="individual-tit-line"></span>
                    <span class="individual-tit-bold">我的收藏</span>
                </div>
                <div class="batchBox" v-show="teamList.length">
                    <div class="batchBoxBtn" v-show="batchCheck">
                        <el-checkbox v-model="checkAll" @change="checkAllChange">全选</el-checkbox>
                    </div>

                    <div class="batchBoxBtnSc" v-show="batchCheck" @click="myCollectDel">
                        <img :src="shachuImg" alt="">
                        <span>删除</span>
                    </div>

                    <div class="batchEdit" @click="batchEditCheck()">
                        {{ batchCheck ? '取消管理' : '批量管理' }}
                    </div>
                </div>
            </div>


            <div class="charter-team-list" v-show="teamList.length">
                <div class="team-list-box"
                     v-for="(item,index) in teamList"
                     :key="item.city_info_id"
                     @click="teamClick(item,index)"
                     :class="{'active': rSelect.indexOf(item)!=-1}"
                >
                    <div class="rightTopImg" v-if="rSelect.indexOf(item)!=-1">
                        <img :src="rightTopImg" alt="">
                    </div>

                    <div class="team-list-box-left">
                        <img :src="item.company_pic" alt="">
                    </div>
                    <div class="team-list-box-middle">
                        <p class="team-title">
                            {{ item.title }}
                        </p>
                        <div class="team-detail">
                            <div class="team-detail-star">
                                <el-rate
                                        v-model="item.stars"
                                        disabled
                                        text-color="#ff9900"
                                        :colors=scoreColors
                                        disabled-void-color="#888">
                                </el-rate>
                            </div>
                            <div class="team-detail-lv">{{ item.avg_comments*100 }}%好评率</div>
                            |
                            <div class="team-detail-serve">
                                服务人数 {{ item.serverCount }} 人
                            </div>
                            |
                            <div class="team-detail-speed">
                                响应速度： {{ item.response_speed }}
                            </div>
                        </div>

                        <div class="team-detail-name">
                            <div class="team-name">
                                {{ item.company_name }}
                            </div>
                            <img src="@/assets/images/charter/cd_icon_vip.png" alt="">
                            <img src="@/assets/images/charter/cd_icon_shiming.png" alt="">
                        </div>
                    </div>

                </div>

                <div class="page-paging" v-show="allNum">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="currentPageChange"
                            :current-page.sync="currentPage"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="10"
                            layout="prev, pager, next, jumper"
                            :total="allNum">
                    </el-pagination>
                </div>
            </div>


            <div class="noTeamList" v-show="!teamList.length">
                <img :src="noCollectionIcon" alt="">
                <span class="noTeamText">暂无收藏内容</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "collection",
        data() {
            return {
                scoreColors: ['#FF5227', '#FF5227', '#FF5227'],
                currentPage: 1,
                shachuImg: require('@/assets/images/charter/shoucang_icon_shanchu.png'),
                rightTopImg: require('@/assets/images/charter/shoucang_icon_xuanzhong.png'),
                rSelect: [],
                teamList: [],
                batchCheck: false,
                checkAll: false,
                allNum: 0,
                noCollectionIcon: require('@/assets/images/persondata/null_img_xitong.png'),
            }
        },
        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            currentPageChange(val) {
                console.log(`当前页: ${val}`);
            },
            teamClick(value, e) {
                if (this.batchCheck) {
                    if (this.rSelect.indexOf(value) !== -1) {
                        this.rSelect.splice(this.rSelect.indexOf(value), 1); //取消
                    } else {
                        this.rSelect.push(value);//选中添加到数组里
                        // this.rSelect.forEach((item)=>{
                        //     item.checkStyle = true;
                        // });
                    }

                    if(this.rSelect.length == this.teamList.length){
                        this.checkAll = true
                    } else {
                        this.checkAll = false
                    }
                } else {
                    // this.$router.push({path: 'charter'});
                }
            },

            // 批量操作
            batchEditCheck() {
                this.batchCheck = !this.batchCheck;
                if (!this.batchCheck) {
                    this.rSelect = [];
                    this.checkAll = false;
                    // this.rSelect.splice(this.rSelect.indexOf(1), 1); //取消
                }
            },

            checkAllChange(val) {
                if (val) {
                    this.teamList.forEach((item) => {
                        if(this.rSelect.indexOf(item) == -1){
                            this.rSelect.push(item);
                        }
                    })
                    this.checkAll = true;
                } else {
                    this.rSelect = [];
                    this.checkAll = false;
                }
            },
            myCollect() {
                this.$axios.get("/myCollectPc").then((res) => {
                    // console.log(res);
                    res = res.data;
                    if (res.status == 200) {
                        this.teamList = res.data.data;
                        this.allNum = res.data.allNum;
                    } else {
                        // layer.msg(res.msg, {icon: 2});
                        this.$message(res.msg);
                    }//请求成功返回的数据
                })
            },
            myCollectDel() {
                var rlength = this.rSelect.length;
                if (rlength == 0) {
                    // layer.msg('请选择数据', {icon: 2});
                    this.$message('请选择数据');
                    return;
                } else {
                    var collect_id = '';
                    for (var i = 0; i < rlength; i++) {
                        collect_id += this.rSelect[i].collect_id + ',';
                    }
                    collect_id = collect_id.slice(0, collect_id.length - 1);
                    this.$confirm('是否删除已选的收藏车队！', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this.$axios.post("/myCollectDel", {
                            collect_id
                        }).then((res) => {
                            // console.log(res);
                            res = res.data;
                            if (res.status == 200) {
                                this.myCollect();
                                this.rSelect = [];
                            } else {
                                // layer.msg(res.message, {icon: 2});
                                this.$message(res.message);
                            }//请求成功返回的数据
                        }).catch((error) => {
                            // layer.closeAll();
                            // layer.msg('系统错误', {
                            //     icon: 2
                            // });
                            this.$message('系统错误');
                        });
                    }).catch(() => {

                    });
                }
            }
        },
        mounted() {
            this.myCollect();
        },
    }
</script>

<style scoped>
    .individual {
        width: 998px;
        border: 1px solid #EEEEEE;
    }

    .individual-box {
        width: 958px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
    }

    .individual-tit {
        height: 49px;
        border-bottom: 1px solid #EEEEEE;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .individual-tit-left {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .individual-tit-line {
        width: 2px;
        height: 14px;
        background: #FF5227;
    }

    .individual-tit-bold {
        margin-left: 10px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .batchBox {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .batchBoxBtn {
        width: 80px;
        height: 28px;
        line-height: 28px;
        cursor: pointer;
    }

    .batchBoxBtnSc {
        width: 80px;
        height: 28px;
        line-height: 28px;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
    }

    .batchBoxBtnSc img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
    }

    .batchBoxBtnSc span {

    }

    .batchEdit {
        width: 80px;
        height: 28px;
        line-height: 28px;
        border: 1px solid #BFBFBF;
        border-radius: 2px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        text-align: center;
        cursor: pointer;
    }

    /*收藏列表*/
    .charter-team-list {
        width: 945px;
        display: flex;
        flex-direction: column;
        margin-top: 20px;
    }

    .team-list-box {
        width: 945px;
        height: 130px;
        background: #FFFFFF;
        border-bottom: 1px dotted #E5E5E5;
        border-top: 2px dotted transparent;
        border-left: 2px dotted transparent;
        border-right: 2px dotted transparent;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        margin-bottom: 10px;
        position: relative;
    }

    .active {
        border: 2px solid #FA592A;
        position: relative;
    }

    .rightTopImg {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 54px;
        height: 54px;
    }

    .rightTopImg img {
        width: 100%;
        height: 100%;
    }

    .team-list-box:hover {
        box-shadow: 0px 0px 20px 0px rgba(51, 51, 51, 0.1);
    }

    .team-list-box-left {
        width: 84px;
        height: 84px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
    }

    .team-list-box-left img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
    }

    .team-list-box-middle {
        width: 820px;
        height: 84px;
        display: flex;
        flex-direction: column;
    }

    .team-title {
        height: 24px;
        line-height: 24px;
        width: 820px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .team-detail {
        margin-top: 8px;
        height: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .team-detail-star {
        margin-right: 20px;
    }

    .team-detail-star >>> .el-rate__icon {
        margin-right: 0;
    }

    .team-detail-lv {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        margin-right: 12px;
    }

    .team-detail-serve {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        margin-left: 12px;
        margin-right: 12px;
    }

    .team-detail-speed {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        margin-left: 12px;
        margin-right: 12px;
    }

    .team-detail-name {
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .team-name {
        max-width: 300px;
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .team-detail-name img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
    }

    .page-paging {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
    }

    .noTeamList {
        width: 945px;
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        align-items: center;
    }

    .noTeamList img {
        width: 280px;
        height: 236px;
        margin-top: 30px;
    }

    .noTeamText {
        width: 182px;
        height: 24px;
        line-height: 24px;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        margin-bottom: 20px;
    }

    /*收藏列表*/

    .individual-info {
        width: 700px;
        margin-top: 30px;
        margin-bottom: 50px;
    }

    .info-img {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .individual-span {
        width: 70px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        text-align: right;
        margin-right: 20px;
    }

    .info-img img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/persondata/children/collection.vue